// frontend/src/components/OrderTimeline.js
import React from "react";

const labelMap = {
  CREATED: "Created",
  OPEN: "Open",
  PLACED: "Placed",
  ACCEPTED: "Accepted",
  IN_TRANSIT: "In Transit",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
};

export default function OrderTimeline({ events = [] }) {
  return (
    <div style={{ padding: 12, border: "1px solid #ddd", borderRadius: 8 }}>
      <h3 style={{ marginTop: 0 }}>Order Timeline</h3>

      {events.length === 0 ? (
        <div>No timeline events yet.</div>
      ) : (
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          {events.map((e, idx) => (
            <li key={idx} style={{ marginBottom: 8 }}>
              <div>
                <strong>{labelMap[e.to_status] || e.to_status}</strong>
              </div>
              <div style={{ fontSize: 12, opacity: 0.75 }}>
                {new Date(e.created_at).toLocaleString()}
                {e.note ? ` • ${e.note}` : ""}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
